import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      "data-clazz": _vm.model.clazz
    }
  }, [_c("div", {
    staticClass: "panelTitle"
  }, [_vm._v(_vm._s(_vm.i18n["userTask"]))]), _c("div", {
    staticClass: "panelBody"
  }, [_c("DefaultDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("选择审批人类别：")]), _c("el-select", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      placeholder: "请选择角色（与用户互斥）",
      value: _vm.model.assignType,
      disabled: _vm.readOnly
    },
    on: {
      change: function change(e) {
        _vm.onChange("assignValue", "");
        _vm.onChange("assignType", e);
      }
    }
  }, [_c("el-option", {
    key: "user",
    attrs: {
      value: "user",
      label: "用户"
    }
  }), _c("el-option", {
    key: "authority",
    attrs: {
      value: "authority",
      label: "角色"
    }
  }), _c("el-option", {
    key: "self",
    attrs: {
      value: "self",
      label: "发起人本人"
    }
  })], 1)], 1), _vm.model.assignType == "user" ? _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("选择用户：")]), _c("el-select", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      placeholder: "请选择用户",
      disabled: _vm.readOnly,
      value: _vm.model.assignValue,
      clearable: "",
      multiple: "",
      filterable: true,
      "filter-method": _vm.filterUsers
    },
    on: {
      change: function change(e) {
        return _vm.onChange("assignValue", e);
      }
    }
  }, _vm._l(_vm.usersCopy, function (user) {
    return _c("el-option", {
      key: user.id,
      attrs: {
        label: user.name,
        value: user.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.model.assignType == "authority" ? _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("选择角色：")]), _c("el-select", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      placeholder: "请选择角色",
      disabled: _vm.readOnly,
      multiple: "",
      value: _vm.model.assignValue,
      clearable: "",
      filterable: true,
      "filter-method": _vm.filterAuthorities
    },
    on: {
      change: function change(e) {
        return _vm.onChange("assignValue", e);
      }
    }
  }, _vm._l(_vm.authoritiesCopy, function (authority) {
    return _c("el-option", {
      key: authority.id,
      attrs: {
        label: authority.name,
        value: authority.id
      }
    });
  }), 1)], 1) : _vm._e(), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", {
    staticStyle: {
      display: "inline"
    }
  }, [_vm._v(_vm._s(_vm.i18n["userTask.dueDate"]) + "：")]), _c("el-date-picker", {
    staticStyle: {
      width: "90%",
      "min-width": "null"
    },
    attrs: {
      type: "datetime",
      placeholder: _vm.i18n["userTask.dueDate.placeholder"],
      disabled: _vm.readOnly,
      value: _vm.model.dueDate
    },
    on: {
      input: function input(value) {
        return _vm.onChange("dueDate", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("视图文件路径（以view开头）")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      placeholder: "请输入视图文件路径（以view开头）",
      type: "view",
      value: _vm.model.view
    },
    on: {
      input: function input(value) {
        _vm.onChange("view", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("步骤：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.step,
      placeholder: "请输入步骤"
    },
    on: {
      input: function input(value) {
        _vm.onChange("step", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("详情说明：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      placeholder: "请输入详情内容",
      type: "textarea",
      value: _vm.model.description
    },
    on: {
      input: function input(value) {
        _vm.onChange("description", value);
      }
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };